if (typeof DosageCalculator !== 'function') {
	class DosageCalculator extends HTMLElement {
		constructor() {
			super();

			this.classes = {
				hidden: 'is-hidden',
				manual: 'dosage-calculator--manual',
			};

			this.selectors = {
				trigger: '.dosage-calculator__text',
				wrapper: '.dosage-calculator__wrapper',
				dosagesScript: '.product__dosages',
				inputRadios: 'input[type="radio"]',
				selectedRadio: 'input[type="radio"]:checked',
				inputWeight: '#input-weight',
				result: '.result__number',
				dailyDosage: '.result__daily-dosage',
				productCount: '.result__product-count',
				dosageCalculatorMultiple: '.dosage-calculator__multiple-dosages',
				shopifySection: '.shopify-section',
				parentGroupCalculator: 'product-group-calculator',
				addToCartButton: '.button[title="Add to cart"]',
				addToCartButtonWrapper: '.dosage-calculator__add-to-cart',
				additionalText: '.rte',
			};

			this.elements = {
				trigger: this.querySelector(this.selectors.trigger),
				wrapper: this.querySelector(this.selectors.wrapper),
				dosagesScript: this.querySelectorAll(this.selectors.dosagesScript),
				inputRadios: this.querySelectorAll(this.selectors.inputRadios),
				inputWeight: this.querySelector(this.selectors.inputWeight),
				result: this.querySelector(this.selectors.result),
				addToCartButton: this.querySelector(this.selectors.addToCartButton),
				additionalText: this.querySelector(this.selectors.additionalText),
				addToCartButtonWrapper: this.querySelectorAll(this.selectors.addToCartButtonWrapper),
			};

			if (this.classList.contains(this.classes.manual)) {
				this.elements.trigger?.addEventListener('click', () => {
					this.elements.wrapper.classList.toggle(this.classes.hidden);
					this.elements.additionalText?.classList.toggle(this.classes.hidden);
				});

				return;
			}

			this.multiple = this.dataset.action === 'multiple' ? true : false;
			this.dosagesJson = this.multiple == true ? this.createDosagesJson() : JSON.parse(this.elements.dosagesScript[0].textContent);
			this.productHandle = this.multiple == true ? this.returnProductHandles() : this.elements.dosagesScript[0].dataset.productHandle;
			this.dosages = {};
			this.unit = '';
			this.weight = 0;
			this.arrangeData();
			this.setWeight();
			this.setUnit();
			if (this.multiple == true) {
				this.calculateMultipleDosages();
				this.addListeners();
				this.updateVisibilityAtAddToCartButton();
			} else {
				this.calculateDosage();
				// this.setMaxInputs();
				this.addListeners();
				this.updateVisibilityAtAddToCartButton();
			}
		}

		updateVisibilityAtAddToCartButton(){
			const productHandle = this.dataset.productHandle;
			const productData = window.store.reviewsData[productHandle];

			const productAvailable = productData?.available === 'true';
			
			this.elements.addToCartButtonWrapper.forEach((wrapper) => {
				if (productAvailable) {
					wrapper.classList.remove(this.classes.hidden);
				} else {
					wrapper.classList.add(this.classes.hidden);
				}
			});
		}

		returnProductHandles() {
			let productHandles = [];
			this.elements.dosagesScript.forEach((script) => {
				productHandles.push(script.dataset.productHandle);
			});
			return productHandles;
		}

		createDosagesJson() {
			let dosages = [];
			this.elements.dosagesScript.forEach((script) => {
				const dosage = JSON.parse(script.textContent);
				dosages = [...dosages, ...dosage];
			});

			console.log(dosages);
			return dosages;
		}

		setWeight() {
			this.weight = parseInt(this.elements.inputWeight.value, 10);
		}

		setUnit() {
			this.unit = this.querySelector(this.selectors.selectedRadio).value.toLowerCase();
			// this.setMaxInputs();
		}

		addListeners() {
			if (this.elements.trigger) {
				this.elements.trigger.addEventListener('click', () => {
					this.elements.wrapper.classList.toggle(this.classes.hidden);
					this.elements.additionalText?.classList.toggle(this.classes.hidden);
				});
			}
			
			this.elements.inputRadios.forEach((radio) =>
				radio.addEventListener('click', () => {
					this.sendConvertEvent();
					this.setUnit();
					if (this.multiple == true) {
						this.calculateMultipleDosages();
					} else {
						this.calculateDosage();
					}
				})
			);
			this.elements.inputWeight.addEventListener('input', () => {
				this.sendConvertEvent();
				this.setWeight();
				if (this.multiple == true) {
					this.calculateMultipleDosages();
				} else {
					this.calculateDosage();
				}
			});

			if (this.elements.addToCartButton) {
				this.elements.addToCartButton.addEventListener('click', () => {
					this.sendConvertEvent();
				});
			}
		}

		arrangeData() {
			if (this.multiple == true) {
				const result = this.dosagesJson.reduce((acc, obj) => {
					const existingObj = acc.find((item) => item.product_handle === obj.product_handle);
					if (existingObj) {
						existingObj.subArray.push(obj);
					} else {
						acc.push({
							product_handle: obj.product_handle,
							subArray: [obj],
						});
					}
					return acc;
				}, []);

				result.forEach((obj) => {
					const restEntries = this.dosagesJson.filter((item) => item.product_handle === obj.product_handle);
					obj[obj.product_handle] = restEntries;
					delete obj.subArray;
					delete obj.product_handle;
				});

				result.forEach((prodDosage) => {
					const productHandle = Object.keys(prodDosage)[0];
					let lbs = [];
					let kg = [];
					prodDosage[productHandle].forEach((dosage) => {
						const min = parseInt(dosage.start, 10);
						const max = parseInt(dosage.end, 10);
						const standardDuration = dosage.product_metafield_values.find((value) => value.includes('days'));
						const standardDurationInDays = parseInt(standardDuration, 10);
						const newValue = standardDurationInDays / parseFloat(dosage.new_value);
						const unit = dosage.product_metafield_values.find((value) => !value.includes('days'));
						// aici am ramas

						lbs.push({
							min: min,
							max: max,
							value: newValue,
							unit: unit,
							dailyDoseLast: parseInt(dosage.product_metafield_values),
							dailyDoseProduct: parseFloat(dosage.new_value),
						});

						kg.push({
							min: Math.round(min / 2.205),
							max: Math.round(max / 2.205),
							value: newValue,
							unit: unit,
							dailyDose: parseInt(dosage.product_metafield_values),
							dailyDoseProduct: parseFloat(dosage.new_value),
						});
					});

					this.dosages[productHandle] = {};
					this.dosages[productHandle].lbs = [...lbs].sort((a, b) => a.value - b.value);
					this.dosages[productHandle].kg = [...kg].sort((a, b) => a.value - b.value);
				});
			} else {
				let lbs = [];
				let kg = [];

				this.dosagesJson.forEach((dosage) => {
					const min = parseInt(dosage.start, 10);
					const max = parseInt(dosage.end, 10);
					const standardDuration = dosage.product_metafield_values.find((value) => value.includes('days'));
					const standardDurationInDays = parseFloat(standardDuration);

					const newValue = standardDurationInDays / parseFloat(dosage.new_value);
					const unit = dosage.product_metafield_values.find((value) => !value.includes('days'));

					lbs.push({
						min: min,
						max: max,
						value: newValue,
						unit: unit,
						dailyDose: parseInt(dosage.product_metafield_values),
						dailyDoseProduct: parseFloat(dosage.new_value),
					});

					kg.push({
						min: Math.round(min / 2.205),
						max: Math.round(max / 2.205),
						value: newValue,
						unit: unit,
						dailyDose: parseInt(dosage.product_metafield_values),
						dailyDoseProduct: parseFloat(dosage.new_value),
					});
				});

				this.dosages[this.productHandle] = {};
				this.dosages[this.productHandle].lbs = [...lbs].sort((a, b) => a.value - b.value);
				this.dosages[this.productHandle].kg = [...kg].sort((a, b) => a.value - b.value);
			}
		}

		calculateDosage() {
			if (!this.weight || this.weight === 0) {
				this.elements.result.textContent = '-';
				return;
			}

			const arrayOfDos = this.dosages[this.productHandle][this.unit].filter((dosage) => this.weight >= dosage.min && this.weight <= dosage.max);
			const dosage = arrayOfDos[arrayOfDos.length - 1];

			if (dosage) {
				this.elements.result.textContent = `${Math.round(dosage.value)}`;
			} else {
				this.elements.result.textContent = '-';
			}
		}

		calculateMultipleDosages() {
			if (this.dataset.cleanse === 'true') {
				let productsData = [];
				const baseValue = 60;
				const parentElement = this.closest(this.selectors.shopifySection);
				const dosagesBoxes = parentElement.querySelectorAll(this.selectors.dosageCalculatorMultiple);
				const productGroupCalculator = parentElement.querySelector(this.selectors.parentGroupCalculator);

				if (!this.weight || this.weight === 0) {
					dosagesBoxes.forEach((box) => {
						box.querySelector(this.selectors.dailyDosage).querySelector('span').textContent = '-';
						box.querySelector(this.selectors.productCount).querySelector('span').textContent = '-';
					});
					productGroupCalculator ? (productGroupCalculator.dataset.productsData = false) : '';
					return;
				}

				dosagesBoxes.forEach((box) => {
					const productHandle = box.dataset.productHandle;
					const initialMeasurement = this.dosages[productHandle][this.unit][0].dailyDose;
					const arrayOfDaysToLast = this.dosages[productHandle][this.unit].filter(
						(dosage) => this.weight >= dosage.min && this.weight <= dosage.max
					);
					const daysToLast = arrayOfDaysToLast[arrayOfDaysToLast.length - 1];

					const unit = daysToLast.unit;
					let dailyDoseOfProduct = daysToLast.dailyDoseProduct;
					let jars = 60 / daysToLast.value;

					if (jars % 1 != 0) {
						const modulo = jars % 1;

						if (modulo <= 0.5) {
							jars = Math.floor(jars) > 0 ? Math.floor(jars) : 1;
						} else {
							jars = Math.ceil(jars);
						}
					}

					if (unit === 'teaspoon') {
						dailyDoseOfProduct = this.calculateFraction(dailyDoseOfProduct);
					}

					box.querySelector(this.selectors.dailyDosage).querySelector('span').textContent = `${dailyDoseOfProduct} ${unit}`;
					box.querySelector(this.selectors.productCount).querySelector('span').textContent = `${jars} jar${jars > 1 ? 's' : ''}`;
					productsData.push({
						handle: productHandle,
						quantity: jars,
					});
				});

				productGroupCalculator ? (productGroupCalculator.dataset.productsData = JSON.stringify(productsData)) : '';
			}
		}

		calculateFraction(number) {
			const gcd = function (a, b) {
				if (b < 0.0000001) return a;

				return gcd(b, Math.floor(a % b));
			};

			const len = number.toString().length - 2;
			let denominator = Math.pow(10, len);
			let numerator = number * denominator;
			const divisor = gcd(numerator, denominator);
			numerator /= divisor;
			denominator /= divisor;
			return Math.floor(numerator) + '/' + Math.floor(denominator);
		}

		sendConvertEvent() {
			window._conv_q = window._conv_q || [];
			window._conv_q.push(["triggerConversion", "100141912"]);
		}

		// setMaxInputs() {
		// 	this.elements.inputWeight.setAttribute('max', this.dosages[this.productHandle][this.unit][0]?.max);
		// }
	}

	if (!customElements.get('dosage-calculator')) {
		customElements.define('dosage-calculator', DosageCalculator);
	}
}
